<template>
  <v-container fluid="fluid">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">Filters</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn>
          </template>
          <span>Reset</span>
        </v-tooltip>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Fetch Data</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-layout row="row" wrap="wrap">
          <v-flex xs12="xs12" sm6="sm6">
            <VueCtkDateTimePicker
              v-model="setDate"
              label="Select Date Range"
              range="range"
              @input="setDateTime"
            ></VueCtkDateTimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">SMS Credits Used by Month</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small color="success" @click="downloadCSV">Download CSV</v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            clearable="clearable"
            single-line="single-line"
            hide-details="hide-details"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="ml-3">
          <v-select
            v-model="recurlyFilter"
            :items="recurlyFilterOptions"
            label="Recurly Status"
            hide-details="hide-details"
          ></v-select>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="filteredItems"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.month }}</td>
            <td class="text-xs-left">{{ props.item.storeID }}</td>
            <td class="text-xs-left">
              <a @click="openLocation(props.item)">{{ props.item.CSPID }}</a>
            </td>
            <td class="text-xs-left">{{ props.item.businessName }}</td>
            <td class="text-xs-right">{{ props.item.sms_count }}</td>
            <td class="text-xs-right">{{ props.item.total_used | currency }}</td>
            <td class="text-xs-left">{{ props.item.recurlyID || '-' }}</td>
          </tr>
        </template>
        <template slot="footer">
          <td colspan="4" class="text-xs-right">Total:</td>
          <td class="text-xs-right">{{ totalSmsCount }}</td>
          <td class="text-xs-right">{{ totalUsed | currency }}</td>
          <td></td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import smsReportsService from '../service'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  name: 'credits-used-by-month',
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(12, 'months'),
        end: this.$moment(new Date()),
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD'),
        toDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      },
      headers: [
        { text: 'Month', value: 'month', sortable: true, width: '10%' },
        { text: 'Store ID', value: 'storeID', sortable: true, width: '8%' },
        { text: 'CSPID', value: 'CSPID', sortable: true, width: '10%' },
        { text: 'Business Name', value: 'businessName', sortable: true },
        { text: 'SMS Count', value: 'sms_count', sortable: true, width: '8%' },
        { text: 'Total Used', value: 'total_used', sortable: true, width: '10%' },
        { text: 'Recurly ID', value: 'recurlyID', sortable: true, width: '15%' },
      ],
      search: null,
      items: [],
      loading: true,
      recurlyFilter: 'all',
      recurlyFilterOptions: [
        { text: 'All', value: 'all' },
        { text: 'Has Recurly', value: 'has' },
        { text: 'No Recurly', value: 'none' },
      ],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'month',
        descending: true,
      },
    }
  },
  components: {
    VueCtkDateTimePicker,
  },
  computed: {
    filteredItems() {
      if (this.recurlyFilter === 'has') {
        return this.items.filter((item) => item.recurlyID)
      }
      if (this.recurlyFilter === 'none') {
        return this.items.filter((item) => !item.recurlyID)
      }
      return this.items
    },
    totalSmsCount() {
      return this.filteredItems.reduce((sum, item) => sum + Number(item.sms_count || 0), 0)
    },
    totalUsed() {
      return this.filteredItems.reduce((sum, item) => sum + Number(item.total_used || 0), 0)
    },
  },
  created() {
    this.getList()
  },
  methods: {
    openLocation(item) {
      this.$router.push({ path: `/location/profile/${item.storeID}` })
    },
    reset() {
      this.setDate = {
        start: this.$moment(new Date()).subtract(12, 'months'),
        end: this.$moment(new Date()),
      }
      this.filter.fromDate = this.$moment(new Date()).subtract(12, 'months').format('YYYY-MM-DD')
      this.filter.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getList()
    },
    setDateTime(val) {
      if (val && val.start && val.end) {
        this.filter.fromDate = this.$moment(val.start, 'YYYY-MM-DD HH:mm a').format('YYYY-MM-DD')
        this.filter.toDate = this.$moment(val.end, 'YYYY-MM-DD HH:mm a').format('YYYY-MM-DD')
        this.getList()
      }
    },
    reloadData() {
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        fromDate: this.filter.fromDate,
        toDate: this.filter.toDate,
      }
      return smsReportsService.getCreditsUsedByMonth(params).then((response) => {
        this.items = response.data.map((item, index) => ({
          ...item,
          id: `${item.storeID}-${item.month}-${index}`,
        }))
        this.loading = false
        return response
      }).catch((error) => {
        this.loading = false
        console.error('Error fetching credits used by month:', error)
      })
    },
    downloadCSV() {
      const csvHeaders = ['Month', 'Store ID', 'CSPID', 'Business Name', 'SMS Count', 'Total Used', 'Recurly ID']
      const csvRows = this.filteredItems.map((item) => [
        item.month,
        item.storeID,
        item.CSPID,
        `"${(item.businessName || '').replace(/"/g, '""')}"`,
        item.sms_count,
        item.total_used,
        item.recurlyID || '',
      ])

      const csvContent = [
        csvHeaders.join(','),
        ...csvRows.map((row) => row.join(',')),
      ].join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'CreditsUsedByMonth.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>
